<template>
  <a-modal
    v-model="visible"
    title="Generate User Registration Link"
    :footer="null"
    width="600px"
    @cancel="handleClose"
  >
    <div class="register-link-popup">
      <!-- Generate Button -->
      <div class="generate-section mb-24">
        <a-button 
          type="primary" 
          size="large" 
          @click="generateRegisterLink"
          :loading="generating"
          icon="plus"
        >
          Generate New Registration Link
        </a-button>
      </div>

      <!-- Generated Link Display -->
      <div v-if="generatedLink" class="link-display-section">
        <a-alert
          message="Registration Link Generated Successfully!"
          type="success"
          show-icon
          class="mb-16"
        />
        
        <div class="link-container">
          <a-input
            :value="generatedLink"
            readonly
            size="large"
            class="link-input"
          >
            <template #addonAfter>
              <a-tooltip title="Copy to clipboard">
                <a-button 
                  type="link" 
                  @click="copyToClipboard"
                  :loading="copying"
                  icon="copy"
                >
                  Copy
                </a-button>
              </a-tooltip>
            </template>
          </a-input>
        </div>

        <div class="link-info mt-16">
          <a-alert
            message="Share this link with the user. They can use it to register their account."
            type="info"
            show-icon
          />
        </div>
      </div>

      <!-- Error Display -->
      <div v-if="error" class="error-section mt-16">
        <a-alert
          :message="error"
          type="error"
          show-icon
        />
      </div>
    </div>
  </a-modal>
</template>

<script>
import userAPI from '../../api/user';

export default {
  name: 'RegisterLinkPopup',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      generating: false,
      copying: false,
      generatedLink: '',
      error: '',
    };
  },
  methods: {
    async generateRegisterLink() {
      this.generating = true;
      this.error = '';
      this.generatedLink = '';

      try {
        const response = await userAPI.generateRegisterLink(this.companyId);
        this.generatedLink = `https://tender.gurmanlogistics.com/register/user?token=${response.token}&company_id=${this.companyId}`;
      } catch (err) {
        this.error = err.response?.data?.error || 'Failed to generate registration link';
      } finally {
        this.generating = false;
      }
    },

    async copyToClipboard() {
      if (!this.generatedLink) return;

      this.copying = true;
      try {
        await navigator.clipboard.writeText(this.generatedLink);
        this.$message.success('Link copied to clipboard!');
      } catch (err) {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = this.generatedLink;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        this.$message.success('Link copied to clipboard!');
      } finally {
        this.copying = false;
      }
    },

    handleClose() {
      this.generatedLink = '';
      this.error = '';
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.register-link-popup {
  .generate-section {
    text-align: center;
  }

  .link-display-section {
    .link-container {
      .link-input {
        font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
        font-size: 12px;
      }
    }
  }

  .link-info {
    .ant-alert {
      text-align: left;
    }
  }
}
</style>
